module.exports = __webpack_public_path__ + "prj_13.e25ac754.jpeg";